<div class="fc-ag-toggle-button">
    <div class="fc-ag-toggle-label" *ngIf="toggleLabel">{{ toggleLabel }}</div>
    <div class="fc-ag-switch-btn-wrapper">
        <div class="fc-ag-switch-btn" [ngClass]="{'fc-ag-switched-on':toggleValue}"
             (click)="toggleButtonValue()">

            <div class="fc-ag-circle" [ngClass]="{'fc-ag-switched-on':toggleValue}"></div>
        </div>
        <div class="fc-ag-switch-btn-label" *ngIf="showCurrentToggleValue">{{ toggleValue ? 'Enabled' : 'Disabled' }}</div>
    </div>
</div>